import { apiClient } from "@/utils/axios";

export default {
  get: async (id: string) => {
    const response = await apiClient.get(`/products/${id}?include=images`);
    return response.data;
  },
};
